import { push } from 'connected-react-router'
import getSearchByVehicleUrl from 'helpers/getSearchByVehicleUrl'

export const confirmVehicleAndMoveToTiresSearch = ({
  vehicle,
  frontTireSize,
  rearTireSize
}) => dispatch =>
  dispatch(push(getSearchByVehicleUrl({ ...vehicle, frontTireSize, rearTireSize })))
